<template>
    <div class="page-content" id="phonebook-list">
        <Titlebar :incrustation="'fa-address-book'">
            <h1>{{ $t('phonebook.titles.list') }}</h1>
        </Titlebar>
        <UiCard>
            <SuperTable
                :tableColumns="tableColumns"
                :tableData="tableData"
                @sort="handleSort"
                @filter="handleFilter"
                @copy="handleCopy"
                @delete="handleDelete"
            />
        </UiCard>
        <Toolbar>
            <div class="row">
                <div class="col">
                    <Btn :class="'default'" v-can="'beepiz-add-phonebooks'">
                        <router-link to="/parameters/phonebooks/new" tag="span"><i class="fa fa-plus"></i><span>{{ $t('phonebook.btns.add') }}</span>
                        </router-link>
                    </Btn>
                </div>
                <div class="col center">
                    <Pagination ref="pagination" @change="handlePagination"></Pagination>
                </div>
                <div class="col">
                </div>
            </div>
        </Toolbar>
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Globals from '@/services/globals.js';
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import Pagination from "@/components/ui/Pagination";
    import UiCard from '@/components/ui/Card'
    import SuperTable from "@/components/ui/Table";
    import Utils from '@/services/utils.js'

    import UserRenderer from "@/components/identifications/TableRowUserRenderer";
    import { useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'PhonebooksList',
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            Pagination,
            SuperTable
        },
        data: () => ({
            count: 0,
            config: {
                perpage: Globals.perPage,
                fields: [],
                page: 1,
                filter: {
                    like: [],
                    equals: []
                },
                sort: []
            },
            tableColumns: {
                global: {
                    sortable: false,
                    noItemsMsg: window.V.$i18n.t('phonebook.emptyTable')
                },
                columns: [
                    {
                        key: 'name',
                        label: window.V.$i18n.t('phonebook.cols.namePhonebook'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: {
                            type: 'text'
                        },
                        linkTo: useDvFlagAccess('beepiz-phonebook-can:update') ? '/parameters/phonebooks/:id' : null,
                        width: '65%'
                    },
                    {
                        key: 'count',
                        label: window.V.$i18n.t('phonebook.cols.nbContacts'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: false,
                        width: '25%'
                    }
                ],
                rowActions: {
                    width: '10%',
                    actions: [
                        {
                            label: Utils.t('global.copy'),
                            class: 'fa fa-copy',
                            event: 'copy'
                        },
                        {
                            label: Utils.t('global.delete'),
                            class: 'fa fa-trash',
                            event: 'delete'
                        }
                    ]
                }
            },
            tableData: [
            ]
        }),

        created(){

        },
        mounted(){
            if (!useDvFlagAccess("beepiz-phonebook-can:read")) {
                this.$router.push({ name: 'AccessDenied', params: { slug: 'phonebooks'} })
            } else {
                if(!useDvFlagAccess("beepiz-phonebook-can:delete")){
                    this.tableColumns.rowActions.actions.splice(1,1);
                }

                if(!useDvFlagAccess("beepiz-phonebook-can:create")){
                    this.tableColumns.rowActions.actions.splice(0,1);
                }
                this.loadData();
            }
        },
        methods: {
            handlePagination: function (page) {
                this.config.page = page;
                this.loadData();
            },
            handleSort: function () {
                this.config.sort = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeSort) {
                        this.config.sort.push(col.activeSort + col.key);
                    }
                }
                this.loadData();
            },
            handleFilter: function () {
                this.config.filter.like = [];
                this.config.filter.equals = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeFilter != '') {
                        if (col.filter && col.filter.type == 'text') {
                            this.config.filter.like.push(col.key + ':' + col.activeFilter);
                        }
                        if (col.filter && col.filter.type == 'list') {
                            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
                        }
                    }
                }
                this.loadData();
            },
            handleCopy: function(item){
                window.V._router.push('/parameters/phonebooks/'+item.id+'/copy');
            },
            handleDelete: function(item){
                var vThis = this;
                window.Vfc.$refs.confirm.show({
                    title: Utils.t('global.deleteModalTitle'),
                    content: Utils.t('global.deleteModalContent'),
                    callbackYes: function () {
                        axios.delete(API.route(API.endpoints.phonebooks.delete, {bookId: item.id}))
                            .then(response => {
                                if(vThis.tableData.length == 1 && vThis.config.page > 1){
                                    vThis.config.page--;
                                }
                                vThis.loadData();
                            })
                            .catch(error => {
                                window.Vfc.$refs.messages.sendMessage('error', error.response.data.message);
                            })
                    }
                });
            },
            loadData: function(){
                axios.get(API.endpoints.phonebooks.index + API.constructQueryParams(this.config))
                    .then(response => {
                        this.tableData = response.data.data;
                        this.count = response.data.meta.pagination.total;
                        this.$refs.pagination.update(response.data.meta.pagination);
                        window.Vfc.$refs.loading.hide();
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
